import { useEffect, useState } from "react";
import { Calendar, DayValue, DayRange } from "@hassanmojab/react-modern-calendar-datepicker";

import {
  Stack,
  Button,
  Card,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  StandardTextFieldProps,
} from "@mui/material";
import DateRangeIcon from "@mui/icons-material/DateRange";

import Modal from "Components/Modal";
import moment from "jalali-moment";

interface IProps extends StandardTextFieldProps {
  name: string;
  label: string;
  data: any | null;
  setData?: (value: any) => void;
  isRange?: boolean;
}

export default function DatePicker({ name, label, size, data, setData, disabled, isRange }: IProps) {
  const [date, setDate] = useState<DayValue | null>(null);
  const [dateRange, setDateRange] = useState<DayRange>({
    from: null,
    to: null,
  });
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => setShowModal((prev) => !prev);

  const handleDeleteDate = () => {
    if (isRange) {
      setDateRange({
        from: null,
        to: null,
      });
      if (setData) {
        setData({});
      }
    } else {
      setDate(null);
    }
  };

  useEffect(() => {
    let from;
    let to;
    if (data && data.created_after) {
      const convertedFormat = moment(data.created_after, "YYYY-M-D").locale("fa").format("YYYY/M/D").split("/");
      from = { day: Number(convertedFormat[2]), month: Number(convertedFormat[1]), year: Number(convertedFormat[0]) };
    } else {
      from = null;
    }
    if (data && data.created_before) {
      const convertedFormat = moment(data.created_before, "YYYY-M-D").locale("fa").format("YYYY/M/D").split("/");
      to = { day: Number(convertedFormat[2]), month: Number(convertedFormat[1]), year: Number(convertedFormat[0]) };
    } else {
      to = null;
    }
    setDateRange({ from, to });
  }, []);

  useEffect(() => {
    if (setData && date) {
      const dateToString = `${date?.year}/${date?.month}/${date?.day}`;
      setData(dateToString);
    }
  }, [date]);

  useEffect(() => {
    if (setData && dateRange) {
      const createdAfter = moment
        .from(`${dateRange?.from?.year}-${dateRange?.from?.month}-${dateRange?.from?.day}`, "fa", "YYYY-M-D")
        .format("YYYY-M-D");
      const createdBefore = moment
        .from(`${dateRange?.to?.year}-${dateRange?.to?.month}-${dateRange?.to?.day}`, "fa", "YYYY-M-D")
        .format("YYYY-M-D");
      let finalObj = {};
      if (createdAfter !== "Invalid date") {
        finalObj = { created_after: createdAfter };
      }
      if (createdBefore !== "Invalid date") {
        finalObj = { ...finalObj, created_before: createdBefore };
      }
      setData(finalObj);
    }
  }, [dateRange]);

  return (
    <>
      <Modal open={showModal} onClose={toggleModal} size="xs">
        <Card sx={{ p: 3, display: "flex", flexDirection: "column", alignItems: "center" }}>
          {isRange ? (
            <Calendar locale="fa" onChange={(value) => setDateRange(value)} value={dateRange} />
          ) : (
            <Calendar locale="fa" onChange={(value) => setDate(value)} value={date} />
          )}
          <Stack direction="row" style={{ width: "100%", justifyContent: "space-between" }}>
            <Button variant="contained" size="large" sx={{ mt: 3, width: "45%" }} onClick={toggleModal}>
              تایید
            </Button>
            <Button variant="contained" size="large" sx={{ mt: 3, width: "45%" }} onClick={handleDeleteDate}>
              بازنشانی
            </Button>
          </Stack>
        </Card>
      </Modal>

      <FormControl fullWidth variant="outlined" size={size}>
        <InputLabel>{label}</InputLabel>
        <OutlinedInput
          type="text"
          label={label}
          inputProps={{ readOnly: true, className: "fa-number" }}
          disabled={disabled}
          value={
            isRange
              ? (dateRange &&
                  dateRange.from &&
                  dateRange.to &&
                  `از ${dateRange.from.day}- ${dateRange.from.month}- ${dateRange.from.year} تا ${dateRange.to.day}- ${dateRange.to.month}- ${dateRange.to.year}`) ||
                ""
              : (data && data[name]) || ""
          }
          endAdornment={
            <InputAdornment position="end">
              <IconButton edge="end" onClick={() => setShowModal(true)} disabled={disabled}>
                <DateRangeIcon fontSize={size} />
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    </>
  );
}
